/**
 * Requests json from a server
 * @param url The URL to request
 * @param method The method to use to request
 * @param body The body
 */
export function request<T, R>(
  url: string,
  method: string,
  body?: T
): Promise<R> {
  return new Promise(async (resolve, reject) => {
    const opts: RequestInit = {
      method
    };
    if (body) {
      opts.body = JSON.stringify(body);
    }
    try {
      const res = await window.fetch(url, opts);
      if (!res.ok) {
        return reject(res.status);
      }
      const body: R = await res.json();
      resolve(body);
    } catch (err) {
      reject(err);
    }
  });
}
